<template>
  <div>
    <!-- Tab Headers -->
    <div role="tablist" class="tabs tabs-border border-b border-base-300 mb-6">
      <button
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab"
        :class="{ 'tab-active': currentTabIndex === index }"
        role="tab"
        @click="currentTabIndex = index"
      >
        {{ tab.label }}
      </button>
    </div>

    <!-- Tab Content -->
    <slot name="tab-content" :currentTab="tabs[currentTabIndex]">
      <transition name="fade" mode="out-in">
        <KeepAlive>
          <component
            :is="tabs[currentTabIndex].component"
            :key="tabs[currentTabIndex].label"
          />
        </KeepAlive>
      </transition>
    </slot>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";

const props = defineProps({
  tabs: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(["update:modelValue"]);

const currentTabIndex = ref(0);
</script>
